import { useEffect } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

// Load package sizes for current countries

const useLoadPackageSizes = (): void => {
  const { values } = useOrderFormik();

  const { updatePackageSizes } = useOrderData();

  const startingCountry = values[OrderFields.STARTING_COUNTRY] || undefined;
  const destinationCountry = values[OrderFields.DESTINATION_COUNTRY] || undefined;
  const deliveryMethod = values[OrderFields.DELIVERY_METHOD] || undefined;

  useEffect(() => {
    updatePackageSizes(startingCountry, destinationCountry, deliveryMethod);
  }, [startingCountry, destinationCountry, updatePackageSizes, deliveryMethod]);
};
export default useLoadPackageSizes;
